const ArrowDown = ({className}) => {
    return (
        <span className={className}>
          <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
              <path
                  d="M5 9L12 16L19 9"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
              />
          </svg>
        </span>
    );
};

export default ArrowDown;
